import { render, staticRenderFns } from "./ReturnReviewStep.vue?vue&type=template&id=c77b433a&"
import script from "./ReturnReviewStep.vue?vue&type=script&lang=ts&"
export * from "./ReturnReviewStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports